import { FC } from 'react';
import { Box } from '@mui/material';

interface CompanyAvatarProps {
  // Accepts either a full Company or a lightweight suggestion — we only read the logo + name.
  company?: {
    name?: string | null;
    logo?: { link?: string | null } | null;
    logoUrl?: string | null;
    effectiveLogoUrl?: string | null;
  } | null;
  size?: number;
}

const CompanyAvatar: FC<CompanyAvatarProps> = ({ company, size = 60 }) => {
  const logoSrc = company?.logo?.link || company?.logoUrl || company?.effectiveLogoUrl;
  const letter = company?.name?.charAt(0)?.toUpperCase() || '?';

  const commonSx = {
    width: `${size}px`,
    height: `${size}px`,
    borderRadius: '8px',
    border: '1px solid #e5e7eb',
    flexShrink: 0,
  };

  if (logoSrc) {
    return (
      <Box
        component="img"
        src={logoSrc}
        alt={company?.name || ''}
        sx={{ ...commonSx, objectFit: 'contain' }}
      />
    );
  }

  return (
    <Box
      sx={{
        ...commonSx,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: `${Math.round(size * 0.4)}px`,
        fontWeight: 600,
        color: '#6b7280',
        backgroundColor: '#f9fafb',
      }}
    >
      {letter}
    </Box>
  );
};

export default CompanyAvatar;
